import React, { useState } from 'react';
import { requestCourier } from 'services';
import { ORDER_COURIER_DELIVERY_TYPES, showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const CourierDeliveryTypeModal = props => {
  const [selectedDeliveryType, setSelectedDeliveryType] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const {
    orderId,
    onSuccess,
    toggleModal,
  } = props;

  const onSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      await requestCourier(orderId, selectedDeliveryType);
      await onSuccess();
      showSuccess('Courier requested for order.');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  }; 
  
  return (
    <form onSubmit={onSubmit} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Order Details</div>
            <div className={styles['modal-title']}>Request Courier Delivery Type</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <input
              type={'radio'}
              name={'courier-delivery-type'}
              onChange={e => setSelectedDeliveryType(e.target.value)}
              value={ORDER_COURIER_DELIVERY_TYPES.IMMEDIATE}
            />
            <div>Immediate</div>
          </div>
          <div className={styles['input-group']}>
            <input
              type={'radio'}
              name={'courier-delivery-type'}
              onChange={e => setSelectedDeliveryType(e.target.value)}
              value={ORDER_COURIER_DELIVERY_TYPES.ROUTABLE}
            />
            <div>Routable</div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            type={'button'}
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={!selectedDeliveryType || loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default CourierDeliveryTypeModal;